'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var noOp = function noOp() {};

var defaultProps = {
  aspectRatio: 'inherit',
  file: '',
  isAutoPlay: undefined,
  isMuted: undefined,
  onAdPlay: noOp,
  onAdResume: noOp,
  onAdSkipped: noOp,
  onAdComplete: noOp,
  onEnterFullScreen: noOp,
  onExitFullScreen: noOp,
  onMute: noOp,
  onUnmute: noOp,
  onAutoStart: noOp,
  onResume: noOp,
  onPlay: noOp,
  onClose: noOp,
  onReady: noOp,
  onError: noOp,
  onAdPause: noOp,
  onPause: noOp,
  onVideoLoad: noOp,
  onOneHundredPercent: noOp,
  onThreeSeconds: noOp,
  onTenSeconds: noOp,
  onThirtySeconds: noOp,
  onTwentyFivePercent: noOp,
  onFiftyPercent: noOp,
  onSeventyFivePercent: noOp,
  onNinetyFivePercent: noOp,
  onTime: noOp,
  onBuffer: noOp,
  onBufferChange: noOp,
  playlist: '',
  useMultiplePlayerScripts: false
};

exports.default = defaultProps;